import React from "react";
import Banner from "./components/Banner";
import BookingForm from "./components/BookingFrom";
import Footer from "./components/Footer";
import "./App.css";
import FleetInformation from "./components/FleetInformation";

const App = () => {
	return (
		<div className="App">
			<Banner />
			<BookingForm />
			<FleetInformation />
			<Footer />
		</div>
	);
};

export default App;